import { DrawerCloseTrigger, DrawerCloseTriggerProps } from '@chakra-ui/react';
import { forwardRef } from 'react';

/*
 * v2's `DrawerCloseButton` was named "Close". v3's `Drawer.CloseTrigger` sets
 * no `aria-label` and the icon callers render inside it is `aria-hidden`, so
 * the button had no accessible name. This restores v2's default (still
 * overridable) — QA selects it by role + name.
 */
const MDrawerCloseButton = forwardRef<
  HTMLButtonElement,
  DrawerCloseTriggerProps
>((props, ref) => (
  <DrawerCloseTrigger ref={ref} aria-label="Close" {...props} />
));

MDrawerCloseButton.displayName = 'MDrawerCloseButton';

export default MDrawerCloseButton;
